import { apiAuth, apiResponseType } from ".";

export const getEmployeesData = (
  page: number = 1,
  unity_id?: string,
  name?: string,
  filters?: Record<string, string>
): apiResponseType => {
  const params = new URLSearchParams({ page: String(page) });
  if (unity_id) params.set("unity_id", unity_id);
  if (name) params.set("name", name);
  Object.entries(filters ?? {}).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  return apiAuth.get(`employees?${params.toString()}`);
};

export const registerEmployeesData = (data) =>
  apiAuth.postForm("/employees/store", data) as apiResponseType;
export const deleteEmployeesData = (uuid: string) =>
  apiAuth.delete(`employees/${uuid}/destroy`) as apiResponseType;
export const updateEmployeesData = (uuid: string, data) =>
  apiAuth.postForm(`employees/${uuid}/update`, data) as apiResponseType;

export const getShowEmployees = (uuid: string) =>
  apiAuth.get(`employees/${uuid}/show`) as apiResponseType;

export const searchEmployeesData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `employees?name=${params.name}${
      params.unity_id ? `` : ""
    }`
  );

export const setStatusEmployees = (uuid: string) =>
  apiAuth.put(`employees/${uuid}/toggle-status`) as apiResponseType;

export const getSelectEmployees = (params: { unity_id?: string; name?: string; is_active?: boolean }) => {
  const queryParams = new URLSearchParams();
  if (params.unity_id) queryParams.append("unity_id", params.unity_id);
  if (params.name) queryParams.append("name", params.name);
  if (params.is_active !== undefined) queryParams.append("is_active", params.is_active ? "1" : "0");
  const queryString = queryParams.toString();
  return apiAuth.get(`employees/select${queryString ? `?${queryString}` : ""}`) as apiResponseType;
};

export const activateEmployeeFromUser = (
  userUuid: string,
  data: {
    unity_id: string;
    sector_id?: string;
    position_id?: string;
    work_schedule_id?: string;
  }
) => apiAuth.post(`employees/from-user/${userUuid}`, data) as apiResponseType;
